import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { handleConfirmBookingAfterPayment } from '../../ApiHandler/AppointmentFunctions';
import 'react-toastify/dist/ReactToastify.css';
import '../Styles/BookingSuccess.css';

const BookingSuccess = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [provider, setProvider] = useState(null);
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        const sessionId = new URLSearchParams(location.search).get('session_id');
        if (sessionId) {
            handleConfirmBookingAfterPayment(
                sessionId,
                (providerInfo) => {
                    setProvider(providerInfo);
                    setSuccess(true);
                    setLoading(false);
                },
                navigate,
                setLoading
            );
        } else {
            toast.error('Invalid payment session', { position: 'top-center' });
            navigate('/login');
        }
    }, [location, navigate]);

    const handleGoToDashboard = () => {
        navigate('/dashboard');
    };

    return (
        <div className="booking-success-container">
            <ToastContainer />
            
            {loading ? (
                <div className="loading-section">
                    <div className="loading-animation">
                        <div className="loading-circle"></div>
                        <div className="loading-circle"></div>
                        <div className="loading-circle"></div>
                    </div>
                    <h2>Processing Your Booking...</h2>
                    <p>Please wait while we confirm your appointment</p>
                </div>
            ) : success ? (
                <div className="success-section">
                    <div className="success-icon">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" 
                                  stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                    
                    <h1>Booking Confirmed!</h1>
                    <p className="success-message">Your appointment has been successfully scheduled</p>
                    
                    {provider && (
                        <div className="provider-info">
                            <h3>Your Healthcare Provider</h3>
                            <div className="provider-card">
                                <div className="provider-avatar">
                                    <span>{provider.name?.charAt(0) || 'P'}</span>
                                </div>
                                <div className="provider-details">
                                    <h4>{provider.name}</h4>
                                    <p>Verified Healthcare Provider</p>
                                </div>
                            </div>
                        </div>
                    )}
                    
                    <div className="next-steps">
                        <h3>What's Next?</h3>
                        <div className="steps-list">
                            <div className="step-item">
                                <div className="step-number">1</div>
                                <div className="step-content">
                                    <h4>Confirmation Email</h4>
                                    <p>You'll receive a confirmation email with appointment details</p>
                                </div>
                            </div>
                            <div className="step-item">
                                <div className="step-number">2</div>
                                <div className="step-content">
                                    <h4>Provider Contact</h4>
                                    <p>Your provider will contact you before the appointment</p>
                                </div>
                            </div>
                            <div className="step-item">
                                <div className="step-number">3</div>
                                <div className="step-content">
                                    <h4>Prepare for Visit</h4>
                                    <p>Gather any relevant medical information</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="action-buttons">
                        <button 
                            className="dashboard-btn"
                            onClick={handleGoToDashboard}
                        >
                            Go to Dashboard
                        </button>
                    </div>
                </div>
            ) : (
                <div className="error-section">
                    <div className="error-icon">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" 
                                  stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                    <h2>Something went wrong</h2>
                    <p>Please try again or contact support</p>
                    <button 
                        className="dashboard-btn"
                        onClick={handleGoToDashboard}
                    >
                        Go to Dashboard
                    </button>
                </div>
            )}
        </div>
    );
};

export default BookingSuccess;